'use client';

import React from 'react';
import {
  Megaphone, DollarSign, TrendingUp, CalendarCheck,
  AlertTriangle, MousePointerClick, Users, Eye
} from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const metrics = [
  {
    id: 'kpi-active-campaigns',
    label: 'Active Campaigns',
    value: '24',
    delta: '+3 this week',
    deltaPositive: true,
    icon: Megaphone,
    iconBg: 'bg-primary/10',
    iconColor: 'text-primary',
    span: 'col-span-1',
    size: 'normal',
  },
  {
    id: 'kpi-spend-today',
    label: "Today\'s Ad Spend",
    value: '$4,821',
    delta: '+12% vs yesterday',
    deltaPositive: true,
    icon: DollarSign,
    iconBg: 'bg-accent/10',
    iconColor: 'text-accent',
    span: 'col-span-1',
    size: 'normal',
  },
  {
    id: 'kpi-roas',
    label: 'Avg. ROAS',
    value: '3.24×',
    delta: '-0.18 from last week',
    deltaPositive: false,
    icon: TrendingUp,
    iconBg: 'bg-positive/10',
    iconColor: 'text-positive',
    span: 'col-span-1 lg:col-span-2',
    size: 'hero',
  },
  {
    id: 'kpi-scheduled',
    label: 'Posts Scheduled Today',
    value: '3',
    delta: '2 Facebook · 1 Instagram',
    deltaPositive: null,
    icon: CalendarCheck,
    iconBg: 'bg-info/10',
    iconColor: 'text-info',
    span: 'col-span-1',
    size: 'normal',
  },
  {
    id: 'kpi-failed',
    label: 'Failed Publishes',
    value: '2',
    delta: 'Needs immediate attention',
    deltaPositive: false,
    icon: AlertTriangle,
    iconBg: 'bg-negative/10',
    iconColor: 'text-negative',
    span: 'col-span-1',
    size: 'alert',
  },
  {
    id: 'kpi-ctr',
    label: 'Avg. CTR (All Campaigns)',
    value: '1.47%',
    delta: '+0.12% vs last 7 days',
    deltaPositive: true,
    icon: MousePointerClick,
    iconBg: 'bg-secondary',
    iconColor: 'text-secondary-foreground',
    span: 'col-span-1',
    size: 'normal',
  },
  {
    id: 'kpi-reach',
    label: 'Total Reach (7 days)',
    value: '1.2M',
    delta: '+84K vs prior week',
    deltaPositive: true,
    icon: Users,
    iconBg: 'bg-primary/10',
    iconColor: 'text-primary',
    span: 'col-span-1',
    size: 'normal',
  },
  {
    id: 'kpi-impressions',
    label: 'Impressions (7 days)',
    value: '4.8M',
    delta: 'Freq. 4.0× avg',
    deltaPositive: null,
    icon: Eye,
    iconBg: 'bg-muted',
    iconColor: 'text-muted-foreground',
    span: 'col-span-1',
    size: 'normal',
  },
];

export default function KPIBentoGrid() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {metrics?.map((m) => {
        const Icon = m?.icon;
        const isHero = m?.size === 'hero';
        const isAlert = m?.size === 'alert';

        return (
          <div
            key={m?.id}
            className={`
              card-base p-5 card-hover
              ${m?.span}
              ${isAlert ? 'border-negative/30 bg-negative-bg' : ''}
              ${isHero ? 'gradient-card-primary text-white' : ''}
            `}
          >
            <div className="flex items-start justify-between mb-3">
              <p className={`text-xs font-semibold uppercase tracking-wider ${isHero ? 'text-white/70' : isAlert ? 'text-negative' : 'text-muted-foreground'}`}>
                {m?.label}
              </p>
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${isHero ? 'bg-white/15' : isAlert ? 'bg-negative/10' : m?.iconBg}`}>
                <Icon size={16} className={isHero ? 'text-white' : isAlert ? 'text-negative' : m?.iconColor} />
              </div>
            </div>
            <p className={`text-3xl font-bold tabular-nums ${isHero ? 'text-white' : isAlert ? 'text-negative' : 'text-foreground'}`}>
              {m?.value}
            </p>
            {m?.delta && (
              <p className={`text-xs mt-2 font-medium ${
                isHero
                  ? 'text-white/70'
                  : m?.deltaPositive === true
                  ? 'text-positive'
                  : m?.deltaPositive === false && !isAlert
                  ? 'text-negative'
                  : isAlert
                  ? 'text-negative font-semibold' :'text-muted-foreground'
              }`}>
                {m?.delta}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}